import { Axios } from 'services/Axios'
import {
  CREATE_EVENTS,
  KLAVIYO_API_BASE_URL,
} from 'utils/constants/EndpointUrls'
import { AXIOS_METHODS } from 'utils/constants/Enums'
import { captureError } from 'utils/sentry/sentry-utils'
import { KlaviyoDataPayload } from 'utils/types/klaviyoPayloadTypes'

export const triggerKlaviyoEvent = async (
  selectedEvent: string,
  payloadData: KlaviyoDataPayload
) => {
  try {
    const payload = {
      data: {
        type: 'event',
        attributes: {
          properties: {
            ...payloadData,
          },
          metric: {
            data: {
              type: 'metric',
              attributes: {
                name: selectedEvent,
              },
            },
          },
          profile: {
            data: {
              type: 'profile',
              id: '',
              attributes: {
                email: payloadData.email,
                properties: {
                  ...payloadData,
                },
              },
            },
          },
        },
      },
    }

    const getKlaviyoHeader: any = () => {
      const headerData = {
        accept: 'application/vnd.api+json',
        revision: '2026-01-15',
        'content-type': 'application/vnd.api+json',
        'Access-Control-Allow-Origin': '*',
      }
      return headerData
    }

    process.env.REACT_APP_KLAVIYO_ABANDON_ENABLE === 'true' &&
      (await Axios.setHeaders(getKlaviyoHeader()).callApi(
        AXIOS_METHODS.POST,
        `${KLAVIYO_API_BASE_URL}${CREATE_EVENTS}${process.env.REACT_APP_KLAVIYO_APP_ID}`,
        undefined,
        payload
      ))
  } catch (error: any) {
    console.error(error)
    captureError(error, {
      response: error.error as Error,
      payload: { ...payloadData, selectedEvent },
      functionName: 'createEvent',
    })
    return false
  }
}
